<template>
  <div id="todayActivetwo" :toiframe="toiframe" :awardIdPointer="awardIdPointer">
    <div id="mask" class="mask"></div>
    <div class="mission">
      <div class="todayCon">
        <p class="sign">
          <img src="~assets/images/missiontwo/lefticon.png" alt />
          {{uiTitle}}
          <img src="~assets/images/missiontwo/righticon.png" alt />
        </p>
        <ul>
          <img class="missionhand" src="~assets/images/hand.png" alt />
          <li v-for="(item,index) in missionList" :id="item.missionId" :key="index">
            <div class="logo">
              <img :src="item.icon" alt />
            </div>
            <div class="litop">
              <div style="display: flex;align-items: center;">
                <div class="pad">
                  <span class="title">{{item.missionDesc}}</span>
                  <span class="over" v-if="item.awardStatus == 2 || item.awardStatus == 1">已完成</span>
                  <span
                    class="rate"
                    v-if="item.awardStatus == 0"
                  >进度:{{item.userProgress}}/{{item.totalProgress}}</span>
                </div>
                <div class="prize">
                  <div
                    class="button receiveOver"
                    v-if="item.awardStatus == 2"
                    disabled="disabled"
                  >领取成功</div>
                  <div
                    class="button receiveCan"
                    v-if="item.awardStatus == 1"
                    @click="goAward(item.missionId,index,item.awardStatus,item.missionId)"
                  >可领取</div>
                  <div
                    :index="index"
                    :class="item.loadstate == 0 || item.loadstate == 1 || item.loadstate == 3 || item.loadstate == 4?'loadingdown button':'goReceive button'"
                    v-if="item.awardStatus == 0"
                    @click="jump(item.jumpType, item.jumpParam1, item.jumpParam2, item.jumpType2, item.jumpParam4, item.awardStatus, item.missionId, item.loadstate, item.packName, index)"
                  >{{item.button}}</div>
                </div>
              </div>
              <p
                class="rightop"
                :style="index<missionList.length-1?'border-bottom: 0.01rem solid #eee':''"
              >
                <b v-for="(i,ind) in item.awardList" :key="ind">
                  <span
                    class="awardName"
                    :class="i.awardName == '金币' ? 'red' : i.awardName == '现金' ? 'red' : 'awardName'"
                  >{{i.awardName == '金币' ? i.awardQuantity : i.awardName == '现金' ? i.awardQuantity/100 : i.awardName}}</span>
                  <span
                    class="count"
                    :class="i.awardName == '金币' ? '金币' : i.awardName == '现金' ? '元' : 'red'"
                  >{{i.awardName == '金币' ? '金币' : i.awardName == '现金' ? '元' : '*' + i.awardQuantity}}</span>
                  <span v-show="ind<item.awardList.length-1">、</span>
                </b>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { setCookie } from "@/utils/base.js";
import { mapState } from "vuex";
import config from "@/../config";
import primaryApi from "@/utils/primaryApi";
import moment from "moment";
import vm from "../../main";
import qs from "qs";
import active from "@/utils/axios/index";

export default {
  data() {
    return {
      uiTitle: "",
      missionList: [] //任务列表
    };
  },
  computed: {
    ...mapState([
      "uuid",
      "onlyId",
      "activityStatus", //活动时间 1:活动期间 2:活动已结束，3:活动关闭 0:活动未开始
      "activityId",
      "time",
      "guide"
    ])
  },
  created() {
    this.missionIdPointer();
  },
  mounted() {
    /* 从后台返回页面-小游戏和乐园都可以用 */
    window["AndroidLifeOnResume"] = () => {
      for (let i = 0; i < this.missionList.length; i++) {
        if (primaryApi.isSource == "sg") {
          //判断是否下载
          if (primaryApi.isDownloaded(this.missionList[i].packName)) {
            //除了1.暂停, 2.成功, 3.失败. 4.进行中 按钮的展示和状态，其他的状态在回调函数中
            //判断是否安装到外部
            if (primaryApi.isInstallOuterApp(this.missionList[i].packName)) {
              this.missionList[i].button = this.missionList[i].buttons;
              this.missionList[i].loadstate = 5;
            } else {
              this.missionList[i].button = "安装";
              this.missionList[i].loadstate = 2;
            }
            //判断每一个的回调状态（这个实在mountend中的下载的回调） 下载状态(int):0 下载, 1.暂停, 2.成功, 3.失败,4.进行中
          } else {
            let status = localStorage.getItem("statusarr");
            this.missionList[i].loadstate = localStorage.getItem("statusarr")
              ? status[i]
              : 0;
            if (this.missionList[i].loadstate == 1) {
              this.missionList[i].button = "继续下载";
            } else {
              this.missionList[i].button = "下载";
              this.missionList[i].loadstate = 0;
            }
          }
        } else if (primaryApi.isSource == "pd") {
          //判断是否安装到外部
          if (primaryApi.isInstallOuterApp(this.missionList[i].packName)) {
            this.missionList[i].button = this.missionList[i].buttons;
            this.missionList[i].loadstate = 5;
          } else {
            let status = localStorage.getItem("statusarr");
            this.missionList[i].loadstate = localStorage.getItem("statusarr")
              ? status[i]
              : 0;
            if (this.missionList[i].loadstate == 1) {
              this.missionList[i].button = "继续下载";
            } else {
              this.missionList[i].button = "下载";
              this.missionList[i].loadstate = 0;
            }
          }
        }
        let beginTime = new moment(
          new Date(new Date(new Date().toLocaleDateString()).getTime())
        ).valueOf(); //00:00:00
        let endTime = new moment(
          new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
          )
        ).valueOf(); //23:59:59
        primaryApi.getAppUsageDuration(
          this.missionList[i].packName,
          beginTime,
          endTime
        ); //获取游戏时长
      }
    };
    /* 233小游戏内/外部下载状态的回调 */
    window["downloadStatus"] = (pkg, gid, status) => {
      //包名，游戏id,状态，路径pkg, gid, status, path,
      for (let i = 0; i < this.missionList.length; i++) {
        //0 下载, 1.暂停, 2.成功, 3.失败, 4.进行中
        if (pkg == this.missionList[i].packName) {
          this.missionList[i].loadstate = status;
          var statusarr = [];
          statusarr[i] = status;
          localStorage.setItem("statusarr", statusarr);
          // 判断是否已下载
          if (status == 1) {
            this.missionList[i].button = "继续下载";
            // 回调函数中的进度为这个进行中的进度
          } else if (status == 2) {
            this.missionList[i].button = "安装";
          } else if (status == 3) {
            this.missionList[i].button = "下载";
          }
        }
      }
    };
    /* 233小游戏内/外部下载进度的回调 */
    window["downloadProgress"] = (pkg, gid, progress) => {
      //包名，游戏id,状态 pkg, gid, progress
      for (let i = 0; i < this.missionList.length; i++) {
        if (pkg == this.missionList[i].packName) {
          var num = progress * 100;
          this.missionList[i].button = num.toFixed(2) + "%";
          this.missionList[i].loadstate = 4;
          this.missionList[i].progress = progress;
        }
      }
    };
    /* 233乐园内/外部下载进度的回调 */
    window["DownloadProgress"] = (pkg, progress) => {
      for (let i = 0; i < this.missionList.length; i++) {
        if (pkg == this.missionList[i].packName) {
          var num = progress * 100;
          this.missionList[i].button = num.toFixed(2) + "%";
          this.missionList[i].loadstate = 4;
          this.missionList[i].progress = progress;
        }
      }
    };
    /* 233乐园内/外部下载失败回调 */
    window["DownloadFailed"] = pkg => {
      this.paradiseDownload(pkg, 3);
    };
    /* 233乐园内/外部下载暂停回调 */
    window["DownloadInterrupt"] = pkg => {
      this.paradiseDownload(pkg, 1);
    };
    /* 233乐园内/外部下载成功回调 */
    window["DownloadSuccess"] = pkg => {
      this.paradiseDownload(pkg, 2);
    };
    //233小游戏获取app使用时长
    window["callbackFetchPkgPlayTime"] = (pkg, timeMills) => {
      this.playTimeCallBack(pkg, timeMills);
    };
    //233乐园内/外部获取app使用时长
    window["GamePlayTime"] = (pkg, timeMills) => {
      this.playTimeCallBack(pkg, timeMills);
    };
    //233乐园请求获取App使用信息权限结果
    window["usagePermissionResult"] = result => {
      if (result == "false") {
        this.tipConshow("您未开启权限，将影响任务统计！");
      } else {
        for (let i = 0; i < this.missionList.length; i++) {
          let beginTime = new moment(
            new Date(new Date(new Date().toLocaleDateString()).getTime())
          ).valueOf(); //00:00:00
          let endTime = new moment(
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            )
          ).valueOf(); //23:59:59
          primaryApi.getAppUsageDuration(
            this.missionList[i].packName,
            beginTime,
            endTime
          );
        }
      }
    };
  },
  methods: {
    //任务list（由于iframe的高度不固定，需要同步请求数据，才可以做到iframe自适应）
    missionIdPointer(missionIdPointer, uuid, activityId) {
      active
        .getMission(
          config.API_HOST + "/apiserv/api/mission/getMission",
          qs.stringify({
            missionIdPointer: this.awardIdPointer,
            uuid: this.uuid,
            activityId: this.activityId,
            onlyId: this.onlyId
          })
        )
        .then(res => {
          if (res.return_code == 200) {
            console.log(res);
            this.uiTitle = res.data.uiTitle;
            for (let i = 0; i < res.data.missionList.length; i++) {
              res.data.missionList[i].buttons = res.data.missionList[i].button;
            }
            this.missionList = res.data.missionList;
            this.$nextTick(() => {
              document.querySelector(".mask").style.height =
                document.querySelector("#todayActivetwo").clientHeight + "px";
              document.querySelector(".mask").style.width = 3.5 + "rem";
            });
            this.btntextloading(); //判断每一个按钮的文字展示
          } else {
            this.tipConshow(res.return_msg);
          }
        });
    },
    //判断每一个按钮的文字展示
    btntextloading() {
      // /apiserv/repository/game/getGameByIdCompat
      // /apiserv/api/repository/game/getGameById
      //循环设置每一个的状态
      for (let i = 0; i < this.missionList.length; i++) {
        active
          .getGameByIdCompat(
            config.API_HOST + "/apiserv/api/repository/game/getGameById",
            {
              id: this.missionList[i].param1
            }
          )
          .then(res => {
            if (res.return_code == 200) {
              this.missionList[i].packName = res.data.detail.packageName;
              this.missionList[i].icon = res.data.detail.iconUrl;
              this.missionList[i].gameDetail = res.data.detail;
              this.missionList[i].progress = 0;
              this.$forceUpdate();
              // //判断每一个按钮的状态0 下载, 1.暂停, 2.成功, 3.失败,4.进行中
              if (primaryApi.isSource == "sg") {
                //小游戏
                // 判断是否已下载
                if (primaryApi.isDownloaded(this.missionList[i].packName)) {
                  //除了1.暂停, 2.成功, 3.失败. 4.进行中 按钮的展示和状态，其他的状态在回调函数中
                  //判断是否安装
                  if (
                    primaryApi.isInstallOuterApp(this.missionList[i].packName)
                  ) {
                    //安装到外部
                    this.missionList[i].button = this.missionList[i].buttons;
                    this.missionList[i].loadstate = 5;
                  } else {
                    this.missionList[i].button = "安装";
                    this.missionList[i].loadstate = 2;
                  }
                } else {
                  var status = localStorage.getItem("statusarr");
                  this.missionList[i].loadstate = localStorage.getItem(
                    "statusarr"
                  )
                    ? status[i]
                    : 0;
                  if (this.missionList[i].loadstate == 1) {
                    this.missionList[i].button = "继续下载";
                  } else {
                    this.missionList[i].button = "下载";
                    this.missionList[i].loadstate = 0;
                  }
                }
              } else if (primaryApi.isSource == "pd") {
                //乐园
                if (
                  primaryApi.isInstallOuterApp(this.missionList[i].packName)
                ) {
                  //安装到外部
                  this.missionList[i].button = this.missionList[i].buttons;
                  this.missionList[i].loadstate = 5;
                } else {
                  var status = localStorage.getItem("statusarr");
                  this.missionList[i].loadstate = localStorage.getItem(
                    "statusarr"
                  )
                    ? status[i]
                    : 0;
                  if (this.missionList[i].loadstate == 1) {
                    this.missionList[i].button = "继续下载";
                  } else {
                    this.missionList[i].button = "下载";
                    this.missionList[i].loadstate = 0;
                  }
                }
              }
              let beginTime = new moment(
                new Date(new Date(new Date().toLocaleDateString()).getTime())
              ).valueOf(); //00:00:00
              let endTime = new moment(
                new Date(
                  new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1
                )
              ).valueOf(); //23:59:59
              if (i == 0) {
                if (primaryApi.hasAppUsagePermission()) {
                  //是否有查看app使用时长权限
                  primaryApi.getAppUsageDuration(
                    this.missionList[i].packName,
                    beginTime,
                    endTime
                  );
                } else {
                  primaryApi.requestAppUsagePermission(); //请求查看app使用时长权限
                }
              } else {
                primaryApi.getAppUsageDuration(
                  this.missionList[i].packName,
                  beginTime,
                  endTime
                ); //获取游戏时长
              }
            } else {
              this.tipConshow(res.return_msg);
            }
          });
      }
    },
    //完成任务，并领取奖励（status: 1:领取成功  2:失败）
    goAward(missionId, index, awardStatus) {
      var continu = this.lock();
      if (continu) {
        active
          .missionAward(
            config.API_HOST + "/apiserv/api/mission/missionAward",
            qs.stringify({
              missionId: missionId,
              uuid: this.uuid,
              activityId: this.activityId,
              onlyId: this.onlyId
            })
          )
          .then(res => {
            if (res.return_code == 200) {
              if (res.data.status == 1) {
                //领取成功
                this.$tea("event_activemodal_missionsuccess_10102", {
                  activityId: this.activityId,
                  missionId: missionId,
                  missionstatus: 1,
                  guide: this.guide ? this.guide : false
                }); //数据埋点
                this.missionList[index].awardStatus = res.data.awardStatus;
                this.missionList[index].totalProgress = res.data.totalProgress;
                this.missionList[index].userProgress = res.data.userProgress;
                this.missionList[index].userLimit = res.data.userLimit;
                this.tipConshow2(res.data.awardList);
                var items = res.data.awardList;
                if (primaryApi.isSource == "sg") {
                  //运行环境为小游戏才需要执行
                  //需要对金币现金做处理
                  for (let i = 0; i < items.length; i++) {
                    if (items[i].awardName == "现金") {
                      Android.addUserBalance(
                        items[i].awardQuantity / 100,
                        "CASH"
                      );
                    } else if (items[i].awardName == "金币") {
                      Android.addUserBalance(items[i].awardQuantity, "GOLD");
                    }
                  }
                }
              } else {
                //领取失败
                this.$tea("event_activemodal_missionsuccess_10102", {
                  activityId: this.activityId,
                  missionId: missionId,
                  missionstatus: 0,
                  guide: this.guide ? this.guide : false
                }); //数据埋点
                this.tipConshow("领取失败");
              }
            } else {
              this.tipConshow(res.return_msg);
            }
          });
      }
    },
    //去完成任务，调用安卓方法进行交互
    jump(
      jumpType,
      jumpParam1,
      jumpParam2,
      jumpType2,
      jumpParam4,
      awardStatus,
      missionId,
      loadstate,
      packName,
      index,
      path
    ) {
      vm.$children[0].$children[0].missionshow = vm.$children[0].$children[0]
        .missionshow
        ? false
        : false;
      document.querySelector(".missionhand").style.display = "none";
      var activehand = document.querySelector(".hand"); //这个是转盘的手指（需要进行判断，有时候页面中没有转盘这个组件）
      if (activehand) {
        document.querySelector(".hand").style.display = "none";
      }
      vm.$children[0].$children[0].$el.style.overflowY = "scroll";
      // document.querySelector('.showmission').style.zIndex = 0;
      //点击判断是否在活动内部
      var continu = this.lock();
      if (continu) {
        this.$tea("event_activemodal_missionbtn_10101", {
          awardStatus: awardStatus,
          activityId: this.activityId,
          missionId: missionId,
          guide: this.guide ? this.guide : false
        }); //数据埋点
        if (primaryApi.isSource == "sg") {
          //小游戏
          if (jumpType == 1) {
            //调用安卓方法
            var bool = Android.activeJump(jumpParam1, jumpParam2); //跳转到app的页面
            if (bool == false) {
              this.tipConshow("版本过低，无法自动跳转，但任务可完成");
            }
          } else if (jumpType == 2) {
            //跳转web——url
            parent.location.href = jumpParam2;
          } else if (jumpType == 4) {
            //判断每一个的按钮的状态loadstate 0 下载, 1.暂停, 2.成功, 3.失败,4.进行中
            if (loadstate == 0 || loadstate == 1 || loadstate == 3) {
              //去下载
              primaryApi.downloadGame(this.missionList[index].gameDetail);
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 11,
                guide: this.guide ? this.guide : false
              });
            } else if (loadstate == 4) {
              //去暂停
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 12,
                guide: this.guide ? this.guide : false
              });
              primaryApi.downloadStop(this.missionList[index].gameDetail);
            } else if (loadstate == 2) {
              //去安装
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 14,
                guide: this.guide ? this.guide : false
              });
              if (!primaryApi.isInstallOuterApp(packName)) {
                //没有安装到外部
                // 直接安装（android 内部会自己调用权限的一些操作）
                primaryApi.installApk(packName);
              } else {
                //已安装，去拉起app
                this.missionList[index].loadstate = 5; //不是不是下载，不是进行中，不是暂停，不是成功，不是失败是按钮原来有的状态
                this.missionList[index].button = this.missionList[
                  index
                ].buttons;
              }
            } else {
              //其他状态的展示(不是web控制的按钮的展示)
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 0,
                guide: this.guide ? this.guide : false
              });
              // 拉起app,直接拉起(android自己去授权)
              primaryApi.openOuterAppByPackage(packName);
            }
          } else {
            //弹出提示信息
            this.tipConshow("赶紧去做任务吧");
          }
        } else if (primaryApi.isSource == "pd") {
          //乐园
          if (jumpType == 4) {
            // this.missionList[index].gameDetail
            //判断每一个的按钮的状态loadstate 0 下载, 1.暂停, 2.成功, 3.失败,4.进行中
            if (loadstate == 0 || loadstate == 1 || loadstate == 3) {
              //去下载
              primaryApi.downloadGame(
                this.missionList[index].gameDetail,
                this.missionList[index].progress
              );
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 11,
                guide: this.guide ? this.guide : false
              });
            } else if (loadstate == 4) {
              //去暂停
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 12,
                guide: this.guide ? this.guide : false
              });
              primaryApi.downloadStop(this.missionList[index].gameDetail);
            } else if (loadstate == 2) {
              //安装成功
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 14,
                guide: this.guide ? this.guide : false
              });
              this.missionList[index].loadstate = 5; //不是不是下载，不是进行中，不是暂停，不是成功，不是失败是按钮原来有的状态
              this.missionList[index].button = this.missionList[index].buttons;
            } else {
              //其他状态的展示(不是web控制的按钮的展示)
              this.$tea("event_activemodal_missionbtn_10102", {
                activityId: this.activityId,
                missionId: missionId,
                btnstatus: 0,
                guide: this.guide ? this.guide : false
              });
              // 拉起app,直接拉起(android自己去授权)
              primaryApi.openOuterAppByPackage(packName);
            }
          } else if (jumpType2 == 6) {
            let strIndex = jumpParam4.lastIndexOf("game_id");
            let gameId = jumpParam4.substring(strIndex + 8, jumpParam4.length);
            let resId = {
              categoryID: 4701,
              gameId: gameId,
              isSpec: 1,
              param1: this.activityId,
              param2: missionId,
              source: 1,
              status: 0
            };
            window.location.href =
              jumpParam4 + "&resId=" + JSON.stringify(resId);
          } else {
            //弹出提示信息
            this.tipConshow("赶紧去做任务吧");
          }
        }
      }
    },
    // 判断活动状态
    lock() {
      if (this.activityStatus == 0) {
        //活动展示期
        this.tipConshow("【" + this.time + "】开启活动，请耐心等待");
        return false;
      } else if (this.activityStatus == 1) {
        $(".button").attr("disabled", false);
        return true;
      } else if (this.activityStatus == 2) {
        this.tipConshow("活动已结束，请等待下次活动");
        return false;
      } else {
        this.tipConshow("活动已关闭，请等待下次活动");
        return false;
      }
    },
    // 处理返回的游戏时长
    playTimeCallBack(pkg, timeMills) {
      //获取到时长
      for (let i = 0; i < this.missionList.length; i++) {
        if (pkg == this.missionList[i].packName) {
          //判断时间是否存在
          if (timeMills) {
            //传给后台进行记录
            if (this.missionList[i].missionType == 1002 && timeMills > 0) {
              var time = Math.floor(timeMills / 1000 / 60);
              this.missionList[i].userProgress = time;
            } else if (
              this.missionList[i].missionType == 1001 &&
              timeMills > 0
            ) {
              var time = 1;
              this.missionList[i].userProgress = time;
            }
            if (
              this.missionList[i].userProgress >=
              this.missionList[i].totalProgress
            ) {
              var param = {
                uuid: this.uuid,
                activityId: this.activityId,
                missionId: this.missionList[i].missionId,
                userProgress: time,
                onlyId: this.onlyId
              };
              $.ajax({
                type: "POST",
                url:
                  config.API_HOST + "/apiserv/api/mission/changeMissionState",
                async: false,
                data: param,
                dataType: "json",
                success: res => {
                  if (res.return_code == 200) {
                    if (!res.data) {
                      this.tipConshow("参数信息不全");
                    } else {
                      if (res.return_code == 200) {
                        if (
                          res.data.awardStatus == 1 &&
                          res.data.missionId == this.missionList[i].missionId
                        ) {
                          this.missionList[i].awardStatus =
                            res.data.awardStatus;
                        }
                      }
                    }
                  }
                }
              });
            } else {
              var time = Math.floor(timeMills / 1000 / 60);
              this.missionList[i].userProgress = time;
            }
          }
        }
      }
    },
    /* 233乐园下载状态回调统一处理 */
    paradiseDownload(pkg, status) {
      for (let i = 0; i < this.missionList.length; i++) {
        //0 下载, 1.暂停, 2.成功, 3.失败, 4.进行中
        if (pkg == this.missionList[i].packName) {
          this.missionList[i].loadstate = status;
          var statusarr = [];
          statusarr[i] = status;
          localStorage.setItem("statusarr", statusarr);
          if (status == 1) {
            this.missionList[i].button = "继续下载";
          } else if (status == 2) {
            this.missionList[i].button = this.missionList[i].buttons;
          } else if (status == 3) {
            this.missionList[i].button = "下载";
          }
        }
      }
    }
  }
};
</script>
<style scoped  lang="less">
button,
p {
  margin: 0;
  padding: 0;
}
#todayActivetwo {
  background: #fff;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-radius: 0.12rem;
}
#mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  border-radius: 0.12rem;
  display: none;
  // background: #FDCB18;
}
.mission {
  background: #fff;
  width: 100%;
  border-radius: 0.12rem;
}
.todayCon {
  width: 100%;
  height: auto;
  margin-top: 0.2rem;
  border: 0.02rem solid #fdcb18;
  position: relative;
  box-sizing: border-box;
  padding: 0 0.12rem;
  border-radius: 0.12rem;
}
.sign {
  width: 90%;
  height: 0.37rem;
  background-size: contain;
  position: absolute;
  top: 0.1rem;
  left: 5%;
  text-align: center;
  font-size: 0.2rem;
  font-weight: 700;
  line-height: 0.4rem;
  color: #ff9500;
}
.sign img {
  width: 0.22rem;
  height: 0.15rem;
}
ul {
  width: 100%;
  height: auto;
  padding: 0.4rem 0;
  list-style: none;
}
.missionhand {
  position: absolute;
  top: 0.8rem;
  left: 86%;
  z-index: 110;
  display: none;
  width: 0.6rem;
}
ul li {
  width: 100%;
  border-radius: 0.04rem;
  margin-top: 0.1rem;
  display: flex;
}
.logo {
  width: 0.4rem;
  height: 0.4rem;
  margin: 0.1rem;
  position: relative;
}
.logo img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.litop {
  width: 80%;
  height: auto;
  display: flex;
  flex-direction: column;
}
.pad {
  width: 70%;
  font-size: 0.15rem;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 0.17rem;
  margin: 0.1rem 0;
}
.over {
  display: inline-block;
  height: 0.14rem;
  background: url("~assets/images/missiontwo/over.svg") no-repeat center;
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(44, 187, 127, 1);
  line-height: 0.14rem;
  text-align: center;
  background-size: cover;
  margin-left: 0.08rem;
}
.rate {
  display: inline-block;
  height: 0.14rem;
  background: #f0f0f0;
  font-size: 0.12rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 400;
  color: #666666;
  line-height: 0.14rem;
  background-size: cover;
}
.prize {
  width: 0.7rem;
  font-size: 0.13rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-left: 0.05rem;
}
.button {
  width: 0.7rem;
  height: 0.28rem;
  border-radius: 0.16rem;
  font-size: 0.12rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.28rem;
  float: right;
  border: 0.01rem;
  outline: none;
  text-align: center;
}
.button:active {
  transform: scale(0.9);
}
.button:active.focus,
.button.active.focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}
.goReceive {
  background: rgba(255, 142, 31, 1);
}
.receiveOver {
  background: rgba(221, 221, 221, 1);
}
.receiveCan {
  background: rgba(253, 79, 45, 1);
}
.loadingdown {
  background: #fff;
  border: 0.01rem solid rgba(255, 142, 31, 1);
  color: rgba(255, 142, 31, 1);
}
.rightop {
  height: 0.3rem;
  text-align: left;
  font-size: 0.12rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.3rem;
}
.rightop b {
  font-weight: 400;
  display: inline-block;
}
.rightop span {
  display: block;
  float: left;
}
.awardName {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.red {
  color: red;
}
@keyframes white {
  20% {
    background: rgba(238, 238, 238, 1);
  }
  50% {
    background: rgba(238, 238, 238, 0);
  }
  75% {
    background: rgba(238, 238, 238, 1);
  }
  100% {
    background: rgba(238, 238, 238, 0);
  }
}
</style>